const types = {
  pdf: 'pdf',
};

export default types;
